export interface NavItemProps {
  title: string;
  description: string;
  link: string;
  sub_nav: {
    title: string;
    link: string;
  }[];
}
export default function NavItem({ title, description, link, sub_nav }: NavItemProps) {
  return (
    <li className="polymer-nav-item">
      <a href={link} className="polymer-nav-item-title">{title}</a>
      <div className="polymer-nav-item-dropdown">
        <div style={{display:"flex",justifyContent:"center",zIndex:-99}}>
          <div className="polymer-nav-item-dropdown-content-wrapper">
            <div className="polymer-nav-item-dropdown-description-container">
              <a href={link} className="polymer-nav-item-dropdown-title">{title}</a>
              <p className="polymer-nav-item-dropdown-description">{description}</p>
            </div>
            <div className="polymer-nav-item-dropdown-separator" />
            <ul className={title == "About Us"?"polymer-nav-item-dropdown-subnav-about-us":"polymer-nav-item-dropdown-subnav"}>
              {sub_nav.map(({title, link}) => (
                <li key={`${link}`} className="polymer-nav-item-dropdown-subnav-item">
                  <a className="polymer-nav-item-dropdown-subnav-link" href={link} title={title}>{title}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </li>
  );
}
